import { z } from 'zod'

export const courtesyInformationSchema = z.object({
  /** 酬賓機票 */
  freeAirlineTicket: z.boolean(),
  /** 商務卡 - 領袖卡 */
  leaderCard: z.boolean(),
  /** 商務卡 - 菁英卡 */
  enterprisePremierCard: z.boolean(),
  /** 哩程兌換券 */
  mileageRedemptionVoucher: z.boolean(),
  /** 購票優惠碼 */
  purchaseDiscountCode: z.boolean(),
  /** 台灣機票折價券 */
  flightVoucher: z.boolean(),
  /** 貴賓室 */
  vipLounge: z.boolean(),
  /** 超額行李 */
  excessBaggage: z.boolean(),
  /** 優先劃位櫃檯 */
  priorityCheckin: z.boolean(),
  /** 優先登機 */
  priorityBoarding: z.boolean(),
  /** 優先裝卸行李 */
  priorityBaggageHandling: z.boolean(),
  /** 升等券 */
  upgradeVoucher: z.boolean(),
  /** 套裝商品 */
  bundleProducts: z.boolean()
})

export interface CourtesyInformation
  extends z.infer<typeof courtesyInformationSchema> {}

export class CourtesyInformation {
  constructor() {
    return {
      freeAirlineTicket: false,
      leaderCard: false,
      enterprisePremierCard: false,
      mileageRedemptionVoucher: false,
      purchaseDiscountCode: false,
      flightVoucher: false,
      vipLounge: false,
      excessBaggage: false,
      priorityCheckin: false,
      priorityBoarding: false,
      priorityBaggageHandling: false,
      upgradeVoucher: false,
      bundleProducts: false
    }
  }
}
